import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MonthGiftComponent } from './month-gift.component';
import { DataShowModule } from "../../component/data-show/data-show.module";//数据状态展示
@NgModule({
  imports: [
    RouterModule.forRoot([{ path: 'monthGift', component: MonthGiftComponent }]),
    CommonModule,
    DataShowModule,
  ],
  declarations: [MonthGiftComponent]
})
export class MonthGiftModule { }
